exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".greyCC {\n  color: #cccccc; }\n\n.grey40 {\n  color: #404040; }\n\n.grey9b {\n  color: #9b9b9b; }\n\n.grey99 {\n  color: #999999; }\n\n.grey88 {\n  color: #888888; }\n\n.green {\n  color: #63B508; }\n\n.orange {\n  color: #FE5815; }\n\n.white-opac {\n  color: rgba(255, 251, 251, 0.6); }\n\n.white-opac3 {\n  color: rgba(255, 251, 251, 0.3); }\n\n.white-opac2 {\n  color: rgba(255, 251, 251, 0.7); }\n\n.black-opac {\n  color: rgba(0, 0, 0, 0.6); }\n\n.link-white {\n  color: white; }\n\na.link-white:focus, a.link-white:visited, a.link-white:active, a.link-white:hover {\n  color: white;\n  text-decoration: none; }\n\n.dotted {\n  border-style: dotted;\n  color: white;\n  border-radius: 25px;\n  border-width: 0.12em; }\n\n.link-add {\n  position: relative;\n  height: 130%;\n  width: 30%;\n  left: 35%; }\n\n.button-ajouter {\n  background-color: rgba(255, 251, 251, 0.3);\n  border-radius: 0.5rem;\n  width: 200px;\n  min-height: 46px; }\n\n.ft-weight500 {\n  font-weight: 500; }\n\n.row-jobs-opac {\n  position: absolute;\n  background-color: rgba(14, 14, 14, 0.1);\n  min-height: 100px;\n  width: 100%;\n  top: 7.5%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/angular/mobilit-web/src/app/jobs/jobs-visions.component.scss
// module id = ../../../../../src/app/jobs/jobs-visions.component.scss
// module chunks = main